<button type="button"
        class="stopWorkflow"
        genTooltip
        [tooltipHtml]="tooltipText"
        [tooltipPosition]="tooltipPosition"
        [ngClass]="cssClass"
        [ngStyle]="styleItem"
        [appendToBody]="true"
        [tooltipShow]="true"
        (click)="stop()"
        [disabled]="isDisabled"
>
    <span *ngIf="actionIconAvailable" class="{{stopAction.icon}}"></span>
    <span *ngIf="actionIconAvailable === false" class="icon__stop"></span>
</button>
